/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { Outlet, useNavigate, useParams} from "react-router-dom"; 
// import Header from "./Layout/Header/Header";
// import Footer from "./Layout/Footer/Footer";

// export default function Main() {  
//   const navigate = useNavigate();
//   const isAuthenticated = localStorage.getItem("token");
 

//   // useEffect(() => {
//   //   if (!isAuthenticated) {
//   //     navigate('/home');
//   //   }
//   // }, [isAuthenticated, navigate]);

//   // if (!isAuthenticated) {
//   //   return null;
//   // }
 
//   return (
//     <div>
//        <Header /> 
//       <div>
//         <Outlet />
//       </div>
//       <Footer />
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom"; 
import Header from "./Layout/Header/Header";
import Footer from "./Layout/Footer/Footer";

export default function Main() { 
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("token");

  const [checkpath, setCheckPath] = useState(false);
  const [currentpath, setcurrentpath] = useState(false);

  const currentUrl = window.location.href;

  useEffect(() => {  
    // console.log(currentUrl.includes("create-custom-print"))
    const shouldRenderHeader = currentUrl.includes("create-custom-print");
    setcurrentpath(shouldRenderHeader); 
    setCheckPath(shouldRenderHeader);
    // console.log(checkpath)
  }, [currentpath, currentUrl]);

  // useEffect(() => {
  //   // Check if user is authenticated, if not, navigate to the home page
  //   if (!isAuthenticated) {
  //     navigate('/home');
  //   }
  // }, [isAuthenticated, navigate]);
 
  return (
    <div>
      {!checkpath && <Header />}
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

